// extracted by mini-css-extract-plugin
module.exports = {"remove-infinite-data-margin":"_1scZf","bottom-fold":"_2SG5v","story-wrapper":"_1IChq","compaign-wrapper":"_3HS_5","not-found":"_25hCP"};